// extracted by mini-css-extract-plugin
module.exports = {"image":"Hero_image__VVR8W"};